import axios from 'axios'
//constantes
const dataInicial = {
    percepciones: [{}],
    movimientos: [{}],
    incidencias: [{}],
    deducciones: [{}],
    tiporiesgo: [{}],
    ramoseguro: [{}],
    controlincapacidad: [{}],
    controlsecuelaconsecuencia: [{}]


}

//types
const OBTENER_MENU_PERCEPCIONES = 'OBTENER_MENU_PERCEPCIONES'
const OBTENER_MENU_MOVIMIENTOS = 'OBTENER_MENU_MOVIMIENTOS'
const OBTENER_MENU_INCIDENCIAS = 'OBTENER_MENU_INCIDENCIAS'
const OBTENER_MENU_DEDUCCIONES = 'OBTENER_MENU_DEDUCCIONES'
const OBTENER_MENU_TIPO_RIESGO = 'OBTENER_MENU_TIPO_RIESGO'
const OBTENER_MENU_RAMO_SEGURO = 'OBTENER_MENU_RAMO_SEGURO'
const OBTENER_MENU_CONTROL_INCAPACIDAD = 'OBTENER_MENU_CONTROL_INCAPACIDAD'
const OBTENER_MENU_SECUELA_CONSECUENCIA = 'OBTENER_MENU_SECUELA_CONSECUENCIA'

const { REACT_APP_API_URL } = process.env;
//reducer
export default function MenusReducer(state = dataInicial, action) {

    switch (action.type) {
        case OBTENER_MENU_PERCEPCIONES:
            return { ...state, percepciones: action.payload }
        case OBTENER_MENU_MOVIMIENTOS:
            return { ...state, movimientos: action.payload }
        case OBTENER_MENU_INCIDENCIAS:
            return { ...state, incidencias: action.payload }
        case OBTENER_MENU_DEDUCCIONES:
            return { ...state, deducciones: action.payload }
        case OBTENER_MENU_TIPO_RIESGO:
            return { ...state, tiporiesgo: action.payload }
        case OBTENER_MENU_RAMO_SEGURO:
            return { ...state, ramoseguro: action.payload }
        case OBTENER_MENU_CONTROL_INCAPACIDAD:
            return { ...state, controlincapacidad: action.payload }
        case OBTENER_MENU_SECUELA_CONSECUENCIA:
            return { ...state, controlsecuelaconsecuencia: action.payload }
        default:
            return state
    }
}
//acciones
export const obtenermenupercepciones = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/percepciones`, requestOptions)
        dispatch({
            type: OBTENER_MENU_PERCEPCIONES,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}


export const obtenermenumovimientos = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/movimientos`, requestOptions)
        dispatch({
            type: OBTENER_MENU_MOVIMIENTOS,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenermenuincidencias = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/incidencias`, requestOptions)
        dispatch({
            type: OBTENER_MENU_INCIDENCIAS,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenermenudeducciones = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/deducciones`, requestOptions)
        dispatch({
            type: OBTENER_MENU_DEDUCCIONES,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenermenutiporiesgo = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/tiporiesgo`, requestOptions)
        dispatch({
            type: OBTENER_MENU_TIPO_RIESGO,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenermenuramoseguro = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/ramoseguro`, requestOptions)
        dispatch({
            type: OBTENER_MENU_RAMO_SEGURO,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}
export const obtenermenucontrolincapacidad = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/controlincapacidad`, requestOptions)
        dispatch({
            type: OBTENER_MENU_CONTROL_INCAPACIDAD,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenermenusecuelaconsecuencia = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/menu/secuelaconsecuencia`, requestOptions)
        dispatch({
            type: OBTENER_MENU_SECUELA_CONSECUENCIA,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}